import React from 'react';
import classNames from 'classnames';

import { ComponentColor, ComponentSize } from './types';

export const Badge = ({
    children,
    className,
    title = '',
    color = ComponentColor.Default,
    size = ComponentSize.MD,
    outline,
    onClick
}: BadgeProps): React.JSX.Element => {
    const badgeClasses = classNames(
        'badge',
        color === ComponentColor.Error ? 'badge-error' : '',
        color === ComponentColor.Info ? 'badge-info' : '',
        color === ComponentColor.Neutral ? 'badge-neutral' : '',
        color === ComponentColor.Success ? 'badge-success' : '',
        color === ComponentColor.Warning ? 'badge-warning' : '',
        color === ComponentColor.Primary ? 'badge-primary' : '',
        color === ComponentColor.Secondary ? 'badge-secondary' : '',
        color === ComponentColor.Accent ? 'badge-accent' : '',
        color === ComponentColor.Ghost ? 'badge-ghost' : '',
        size === ComponentSize.XL ? 'badge-xl' : '',
        size === ComponentSize.LG ? 'badge-lg' : '',
        size === ComponentSize.MD ? 'badge-md' : '',
        size === ComponentSize.SM ? 'badge-sm' : '',
        size === ComponentSize.XS ? 'badge-xs' : '',
        outline ? 'badge-outline' : '',
        className
    );

    return (
        <div className={badgeClasses} onClick={onClick} title={title}>
            {children}
        </div>
    );
};

interface BadgeProps {
    children?: React.ReactNode;
    className?: string;
    title?: string;
    color?: ComponentColor;
    size?: ComponentSize;
    outline?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export default Badge;
